import { render, staticRenderFns } from "./edit-survey.vue?vue&type=template&id=4cdd2f62&scoped=true&"
import script from "./edit-survey.vue?vue&type=script&lang=js&"
export * from "./edit-survey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cdd2f62",
  null
  
)

export default component.exports